import { useEffect, useState, useRef } from "react";
import styles from "./style.module.scss";
import userImage from "../../../assets/images/user";
import { CheckOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useOutsideAlerter } from "../../../hooks/utils";
import profileActions from "../../../redux/profile/actions";

const LeftSideComponent = () => {
  const dispatch = useDispatch();
  const { currentUser, creditzIds = [] } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
    creditzIds: state.profile.creditzIds,
  }));

  const wrapperRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [status, setStatus] = useState("Independent");
  const [newStatus, setNewStatus] = useState("");

  useOutsideAlerter(wrapperRef, setShowForm);

  useEffect(() => {
    setNewStatus("");
    setStatus(currentUser.status || "Independent");
  }, [currentUser.status]);

  const changeStatus = (st) => {
    setShowForm(false);
    if (st === "Independent") {
      setNewStatus("");
    }
    setStatus(st);
  };

  const onBlurNewStatus = () => {
    dispatch({
      type: profileActions.UPDATE_USER_STATUS,
      payload: {
        currentUser: {
          ...currentUser,
          status: newStatus ? `${status} ${newStatus}` : status,
        },
      },
    });
  };

  return (
    <div className={styles.leftSideComponent}>
      <div
        className={styles.avatarContainer}
        style={
          currentUser.coverImageUrl
            ? { backgroundImage: `url(${currentUser.coverImageUrl})` }
            : {}
        }
      />
      <div className={styles.thumb}>
        <img src={currentUser?.profileImageUrl || userImage()} alt="userImage" />
        {currentUser.isVerified && (
          <div className={styles.selected}>
            <CheckOutlined style={{ color: "#C86DD7" }} />
          </div>
        )}
      </div>
      <div className={styles.infoContainer}>
        <p className={styles.name}>{currentUser.username}</p>
        <div className={styles.artist}>
          <span>{currentUser.accountType}</span>
        </div>
        <div className={styles.genre}>
          {currentUser.genre?.split(",").map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
        <div className={styles.statisticsContainer}>
          <div className={styles.statistics}>
            <div className={styles.item}>
              {currentUser.connect_counts} <br /> Connections
            </div>
            <div className={styles.vertical} />
            <div className={styles.item}>
              {creditzIds.length} <br /> Credits
            </div>
          </div>
        </div>
        <div className={styles.bottomContainer}>
          <div className={styles.statusContainer} ref={wrapperRef}>
            <div className={styles.status}>Status</div>
            <div className={styles.value} onClick={() => setShowForm(true)}>
              {status}
            </div>
            {showForm && (
              <div className={styles.options}>
                <div
                  onClick={() => changeStatus("Independent")}
                  className={styles.option}
                >
                  Independent
                </div>
                <div
                  onClick={() => changeStatus("Working At")}
                  className={styles.option}
                >
                  Working At
                </div>
                <div
                  onClick={() => changeStatus("Signed to")}
                  className={styles.option}
                >
                  Signed to
                </div>
              </div>
            )}
            {(status === "Working At" || status === "Signed to") && (
              <input
                onChange={(e) => setNewStatus(e.target.value)}
                onBlur={onBlurNewStatus}
              />
            )}
          </div>
          {currentUser.managementType && (
            <div className={styles.status}>{currentUser.managementType}</div>
          )}
          {currentUser.managementUser && (
            <div className={styles.username}>@{currentUser.managementUser}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeftSideComponent;
